import {Row, Col, Progress} from "reactstrap";
import {Link} from "react-router-dom";
import {formatIso8601DateTime, humanizeDuration} from "../../utils/functions";

const BenchmarkItem = (props: any) => {
  if (props === undefined || !props.Cpu) {
    return <></>;
  }

  const max: number = Math.round((props.MaxFps / props.scaleFactor) * 100);
  const avg: number = Math.round((props.AvgFps / props.scaleFactor) * 100);
  //const min: number = Math.round((props.MinFps / props.scaleFactor) * 100);
  const pc1: number = Math.round((props.Pc1Fps / props.scaleFactor) * 100);

  const crowdedness: number = Math.round(props.Crowdedness * 100);

  return (
    <>
      <Row className="progress-benchmark-row">
        <Col md="1" className="text-center">
          <div className="number-circle">
            <span>{props.rank}</span>
          </div>
        </Col>
        <Col md="4">
          <h5 className="benchmark-item">
            {props.showLinks && (
              <Link
                to={`/benchmarkactivities/${props.world}/${props.profile}/${props.resolution}/${encodeURIComponent(
                  props.Cpu
                )}/${encodeURIComponent(props.Gpu)}${props.year !== "0" ? `/${props.year}` : ""}${
                  props.quarter !== "0" ? `/${props.quarter}` : ""
                }`}
              >
                {props.Cpu}
                <br />
                {props.Gpu}
              </Link>
            )}

            {!props.showLinks && (
              <>
                {props.Cpu}
                <br />
                {props.Gpu}
              </>
            )}
          </h5>
          <p className="benchmark-item-subtext">
            {props.Platform} Client: {props.GameClientVersion}, Date:{" "}
            {formatIso8601DateTime(props.StartTime, props.timezoneOffsetMinutes)}
            <br />
            Duration: {humanizeDuration(props.Duration)}, Crowding: {crowdedness}%
          </p>
        </Col>
        <Col md="7">
          <div className="bar-wrap">
            <div className="bar-label">Max FPS</div>
            <Progress className="progress-benchmark" color="success" value={max}>
              {props.MaxFps}
            </Progress>
          </div>
          <div className="bar-wrap">
            <div className="bar-label">Avg FPS</div>
            <Progress className="progress-benchmark" color="info" value={avg}>
              {props.AvgFps}
            </Progress>
          </div>
          <div className="bar-wrap">
            <div className="bar-label">
              P<sub>1</sub> FPS
            </div>
            <Progress className="progress-benchmark" color="warning" value={pc1}>
              {props.Pc1Fps}
            </Progress>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default BenchmarkItem;
